module.exports = __webpack_public_path__ + "img/car_icon16.3c28170c.png";